import { DirectDepositAccount } from '../../schemas/directDepositAccount';

export function formatDirectDepositNumbers({
  transit,
  institution,
  maskedAccount,
}: DirectDepositAccount) {
  return `${transit}-${institution} ${maskedAccount}`;
}
